"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getChiliPiperIntegrationState = void 0;

var _ramda = require("ramda");

var getChiliPiperIntegrationState = (0, _ramda.path)(['personalIntegration', 'chiliPiperIntegration']);
exports.getChiliPiperIntegrationState = getChiliPiperIntegrationState;